module.exports = __webpack_public_path__ + "static/media/pinkTheme-girl.6f352f7d.svg";